export const HOME = '/';
export const LOGIN = '/login';
export const REGISTER = '/register';
export const DASHBOARD = '/dashboard';
export const JOBS = '/jobs';
export const CANDIDATES = '/candidates';
export const HIRING_APPROVALS = '/hiring-approvals';
export const RECRUITERS = '/recruiters';
export const COMPANIES = '/clients';
export const MESSAGES = '/messages';
export const RECRUITER_MANAGEMENT = '/recruiter-management';
export const JOB_ASSIGNMENTS = '/job-assignments';
export const ANALYTICS = '/analytics';
export const MASTER_CONTRACTS = '/master-contracts';
export const RECRUITER_CONTRACTS = '/recruiter-contracts';
export const RECRUITER = '/recruiter';
export const CLIENT = '/client';
export const INVITE = '/invite';
export const ONBOARD = '/onboard';
export const TERMS = '/terms';
export const RESET_PASSWORD = '/reset-password';
export const CALENDAR = '/calendar';
export const GOOGLE_REDIRECT_HANDLER = '/signInCallback/google';
export const PROFILE_SETTINGS = '/profile';
export const CANDIDATES_SPECIFICATION_SETTINGS = '/candidates-specification';
export const ATS_SETTINGS = '/ats-settings';
export const RECRUITER_COMPANY_SETTINGS = '/recruiter-company';
export const RECRUITER_COMPANY_TYPE_SETTINGS = '/recruiter-company/type';
export const RECRUITER_COMPANY_USERS_SETTINGS = '/recruiter-company/users';
export const RECRUITER_PROJECTS = '/recruiter-projects';
export const ATS_DEFAULT_MAPPINGS = '/ats-settings/default-mappings';
export const NOTIFICATIONS_SETTINGS = '/notifications-settings';
export const PERMISSIONS_SETTINGS = '/permissions-settings';
export const AGENCY_PORTAL = '/agency-portal';
export const NOTIFICATIONS = '/notifications';
export const GUEST = '/guest';
export const PRIVACY_POLICY = '/privacy-policy';
export const RATE = '/rate';
export const MAGIC_LINK = '/loading';
export const MAGIC_LINK_INIT = '/links';
export const EMBED = '/embed';
export const MFA_SETUP = '/mfa-setup';
